import { useEffect, useState } from "react";
import api from "../api/axios";
import { APPROVER_ROLES } from "../constants/roles";
import AccessDenied from "../pages/errorpages/AccessDenied";
import { useCurrentUser } from "../utilities/currentUser";
import { userHasAnyRole } from "../utils/leadershipRoles";
import ProtectedRoute from "./ProtectedRoute";

/**
 * Approver pages: same rule as the sidebar link - the user holds an approver role, or one of their
 * roles is an active step of a company's approval chain (GET /api/my-approver-status).
 */
const ApproverGate = ({ children }) => {
  const { user, ready } = useCurrentUser();
  const hasApproverRole = userHasAnyRole(user, APPROVER_ROLES);
  const [canApprove, setCanApprove] = useState(null);

  useEffect(() => {
    // Wait for the first role refresh: stale roles from localStorage must not decide anything.
    if (!ready || hasApproverRole) return undefined;
    let cancelled = false;
    api
      .get("/api/my-approver-status")
      .then((res) => !cancelled && setCanApprove(Boolean(res.data?.can_approve)))
      .catch(() => !cancelled && setCanApprove(false));
    return () => {
      cancelled = true;
    };
  }, [ready, hasApproverRole]);

  if (!ready) return <div className="p-4 text-muted">Loading...</div>;
  if (hasApproverRole) return children;
  if (canApprove === null) {
    return <div className="p-4 text-muted">Loading...</div>;
  }
  return canApprove ? children : <AccessDenied />;
};

const ApproverRoute = ({ children }) => (
  <ProtectedRoute>
    <ApproverGate>{children}</ApproverGate>
  </ProtectedRoute>
);

export default ApproverRoute;
